import React from "react";
import { useNavigate } from "react-router-dom";

import FileUpload from "components/FileUpload/FileUpload";
import { Heading2 } from "widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FileUploadsHistory from "components/FileUploadsHistory/FileUploadsHistory";
import { UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID } from "constants/constants";

import styles from "./UpdatePackageSchedule.module.scss";

const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};

const UpdatePackageSchedule = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <Heading2 heading="Update Package Schedule" />
      <FileUpload
        scriptId={UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID}
        uploadLabel="Update Package Schedule"
      />
      <Heading2 heading="Recently Updated Package Schedule" />
      <FileUploadsHistory scriptId={UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID} />
    </div>
  );
};
export default UpdatePackageSchedule;
